
  import { CROSS_SELL } from '~/constants/carousel.js';

  export default {
    props: {
      boughtProduct: {
        type: String,
        default: null
      },
      customHeader: {
        type: String,
        default: null
      },
      removeProduct: {
        type: String,
        default: ''
      }
    },
    computed: {
      items () {
        return CROSS_SELL;
      },
      filteredItems () {
        let filteredProducts = this.items.products;
        if (this.removeProduct) {
          filteredProducts = this.items.products.filter(item => item.name !== this.removeProduct);
        }
        return {
          ...this.items,
          products: filteredProducts
        };
      }
    }
  };
